<template>
  <div class="employees-list">
    <div class="employees-cards mt-3">
      <b-row>
        <b-row class="justify-content-between m-0">
          <div class="mb-5 col-4">
          <b-form-input
            v-model="search"
            type="text"
            class="form-input"
            placeholder="بحث عن موظف"

          />
        </div>
        <div class="mb-5 col-3 d-flex align-items-center justify-content-end">
          <b-button variant="primary" @click="openAddModal">اضافة موظف</b-button>

        </div></b-row>
        <vue3-datatable
          skin="bh-table-bordered "
          paginationInfo=""
          :rows="employeesList.employees"
          :columns="columns"
          :showPageSize="false"
          :totalRows="employeesList.count"
          showNumbers
          pagination
          :isServerMode="true"
          @change="changeServer"
        >
          <template #actions="data">
            <div class="flex gap-4">
              <div class="icon theme-color">
                <i class="fas fa-phone-volume"></i>
              </div>
              <router-link
                :to="{ name: 'show-employee', params: { id: data.value.id } }"
              >
                <vue-feather size="16" stroke="blue" type="eye"></vue-feather>
              </router-link>
            </div>
          </template>
          <template #certified="data">
            <div v-if="data.value.certifications">
                <span v-if="data.value.certifications.length>0" >نعم</span>
                <span v-else >لا</span>

            </div>

          </template>
        </vue3-datatable>
      </b-row>
    </div>
    <EditemployeeProfileModal ref="editEmployeeProfileModal" />

  </div>
</template>

  <script>
import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";
import EditemployeeProfileModal from './control-employee/EditEmployee.vue';

export default {
  components: { Vue3Datatable ,EditemployeeProfileModal },
  name: "EmployeesList",
  props: {
    employeesList: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },

  },

  data() {
    return {
      search: null,
      APIURL: "companies",
      editComponent: "edit-employee",
      viewContent: true,
      type: "page",

    };
  },
  watch: {
    search(newSearch, oldSearch) {
      if (newSearch !== oldSearch) {
        this.$emit("search", newSearch); // Emit the search event to the parent
      }
    },
  },

  computed: {
    filteredEmployees() {
      // Filter employees based on the search input
      if (!this.search) {
        return this.employeesList;
      }

      const searchTerm = this.search.toLowerCase();
      return this.employeesList.filter((employee) =>
        this.columns.some((column) => {
          const key = column.key;
          const value = employee[key];
          return value && value.toLowerCase().includes(searchTerm);
        })
      );
    },
  },
  methods: {
    openAddModal() {
      // Call the openModal method from the modal component
      this.$refs.editEmployeeProfileModal.openModal();
    },
    changeServer({ current_page  }) {
      this.$emit("page-change", current_page );
    },
  },
};
</script>

  <style lang="">
</style>
